module.exports = __webpack_public_path__ + "1b1bcb91aeabe50a087cb895d330b20e.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-94.cur
// module id = 486
// module chunks = 0